var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ckeditor',_vm._g({attrs:{"config":_vm.editorConfig,"editor":_vm.editor,"value":_vm.value},on:{"input":_vm.onInput}},_vm.listeners)),_c('image-gallery-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }